<div class="badge badge--{variant}">

    <slot />

</div>

<style>

    .badge {
        display: inline-block;
        padding: 0 0.5rem;
        font-size: 0.8rem;
        line-height: 1.25rem;
        font-weight: bold;
        border-radius: 0.5rem;
        box-shadow: 0 0 0.5rem rgba(0, 0, 0, 0.25);
    }

    .badge.badge--primary {  
        color: var(--white);      
        background-color: var(--primary);
    }

    .badge.badge--secondary {   
        color: var(--white);     
        background-color: var(--secondary);
    }
    
    .badge.badge--success {
        color: var(--white);
        background-color: var(--success);
    }
    
    .badge.badge--info {     
        color: var(--white);   
        background-color: var(--info);
    }
    
    .badge.badge--warning {  
        color: var(--white);      
        background-color: var(--warning);
    }
    
    .badge.badge--danger {        
        color: var(--white);
        background-color: var(--danger);
    }
    
    .badge.badge--light {        
        color: var(--black);
        background-color: var(--light);
    }
    
    .badge.badge--dark {     
        color: var(--white);   
        background-color: var(--dark);
    }

</style>

<script>
    export default {
        data() {
            return {
                variant: 'primary'
            }
        }
    }
</script>